import { render, staticRenderFns } from "./dingdantixing.vue?vue&type=template&id=0130b454&scoped=true&"
import script from "./dingdantixing.vue?vue&type=script&lang=js&"
export * from "./dingdantixing.vue?vue&type=script&lang=js&"
import style0 from "./dingdantixing.vue?vue&type=style&index=0&id=0130b454&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0130b454",
  null
  
)

export default component.exports